
import { Box } from "@mui/material";
import FormikControl from "components/wrapperComponents/FormikControl";
import { msgTypes } from "constants/msgTypes";
import { Form, Formik } from "formik";
import { AnnouncementModel } from "model/screensModels/AnnouncementModel";
import { useEffect, useRef, useState } from 'react';
import { AnnouncementSchema } from "schemas/menu/announcement/AnnouncementSchema";
import { LocalStorageService } from "services/auth/LocalStorageService";
import { AnnouncementService } from "services/menu/announcementService/AnnouncementService";


export const CreateAnnouncement = ({ setFlag, updateRecord, loadRecentAnnouncement }) => {

  const [initialValue, setInitialValue] = useState(new AnnouncementModel());
  const [viewMode, setViewMode] = useState(false);
  const formikRef = useRef(null);
  const fileInputRef = useRef(null);

  const onSubmit = async (values: AnnouncementModel) => {
    addAnnouncement(values)
  }

  useEffect(() => {
    if (updateRecord) {
      setInitialValue(updateRecord)
    }
  }, [updateRecord])




  const prepareRequestBody = async (values: AnnouncementModel) => {
    const prepareData = new AnnouncementModel();
    if (values.announcementId != "" && values.announcementId != undefined) {
      prepareData.announcementId = values.announcementId;
    }
    prepareData.title = values.title ? values.title : '';
    prepareData.message = values.message ? values.message : '';
    prepareData.attachment = values.attachment ? values.attachment : "";
    prepareData.status = values.status ? values.status : false;

    //get Company Id
    const userDetails = await LocalStorageService.getUserDetails();
    if (userDetails !== '') {
      const companyDetails = JSON.parse(userDetails)
      prepareData.companyId = companyDetails.companyId;
    }

    return prepareData;
  }


  const addAnnouncement = async (values: AnnouncementModel) => {
    const requestData = await prepareRequestBody(values);
    const res = await AnnouncementService.saveAnnouncement(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setInitialValue(new AnnouncementModel())
      loadRecentAnnouncement();
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('imageFile', null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  }

  return (
    <>

      <div className="sub-content-sec recently-blog">
        <Formik
          enableReinitialize={true}
          initialValues={initialValue}
          validationSchema={AnnouncementSchema}
          onSubmit={onSubmit}
          innerRef={formikRef}

        >
          {({ dirty, isValid, values }) => (
            <Form>
              <Box className="form-box bg-white p-3">
                <div className="row">
                  <div className="col-md-12 position-relative">
                    <FormikControl
                      control="textfield"
                      name="title"
                      label="Title"
                      placeholder="Enter Title"
                      requiredField
                      disabled={viewMode}
                    />
                  </div>

                  <div className="col-md-12 position-relative">
                    <FormikControl
                      control="textfield"
                      name="message"
                      label="Message"
                      className="message-field"
                      placeholder="Write Message"
                      requiredField
                      multiline
                      rows={8}
                      disabled={viewMode}
                    />
                  </div>

                  <div className="col-md-6 position-relative">
                    <FormikControl
                      control="uploadImage"
                      name="attachmentFile"
                      label="Attachment"
                      tooltip = {[msgTypes.DOCUMENT_TYPE.PDF,msgTypes.DOCUMENT_TYPE.TXT,msgTypes.DOCUMENT_TYPE.JPG, 
                        msgTypes.DOCUMENT_TYPE.JPEG,msgTypes.DOCUMENT_TYPE.PNG, msgTypes.FILE_SIZE_ALLOW_3MB]}
                      nameUrl="attachment"
                      requiredField
                      disabled={viewMode}
                      inputRef={fileInputRef}
                    />
                  </div>
                  <div className="col-12  d-flex justify-content-end">
                    <FormikControl
                      control="button"
                       className="btn btn-submit ml-3"
                      color="primary"
                      label={
                        values.announcementId === "" ? "Save" : "Update"
                      }
                      type="submit"
                      disabled={!dirty || !isValid}
                    />&nbsp;&nbsp;
                    <FormikControl
                      control="button"
                      className="btn btn-cancel"
                      color="warning"
                      label="Back"
                      type="reset"
                      onClick={() => {
                        setFlag(false);
                      }}
                    />
                  </div>
                </div>
              </Box>
            </Form>
          )}
        </Formik>
      </div>
    </>
  )
}
